export default "__VITE_ASSET__BL8B$zfT__"